import { render } from "./DeviationDescriptionInput.vue?vue&type=template&id=588b13d1"
import script from "./DeviationDescriptionInput.vue?vue&type=script&lang=ts"
export * from "./DeviationDescriptionInput.vue?vue&type=script&lang=ts"
script.render = render

export default script
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInput});
